export default __webpack_public_path__ + "static/media/plusIconSquare.3c7b3451.svg";